import { endpoints, host } from '@config/endpoints';
import { CancelToken } from 'axios';
import request from './request';

export const getLocationsByCountry = async (HubIds: string[], CancelToken: CancelToken | null = null) => {
    const { path, method } = endpoints.hubs.getLocationsByCountry;

    let err = null;
    let res: any = null;
    let options = {};
    if (CancelToken)
        options = { cancelToken: CancelToken };

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds },
            options,
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};